import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/Button';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Головна',
    href: '#'
  }, {
    name: 'Про нас',
    href: '#mission'
  }, {
    name: 'Активності',
    href: '#activities'
  }, {
    name: 'Новини',
    href: '#news'
  }, {
    name: 'Контакти',
    href: '#footer'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#0A5E5C] shadow-lg py-3' : 'bg-[#0A5E5C]/90 backdrop-blur-sm py-5'}`} data-id="element-115">
      <div className="container mx-auto px-4 md:px-6" data-id="element-116">
        <div className="flex items-center justify-between" data-id="element-117">
          {/* Logo */}
          <a href="#" className="flex items-center gap-2 group" data-id="element-118">
            <div className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center group-hover:bg-white/20 transition-colors" data-id="element-119">
              <span className="text-[#D4A843] font-serif font-bold text-xl" data-id="element-120">
                FG
              </span>
            </div>
            <span className="text-white font-serif font-bold text-xl tracking-wide" data-id="element-121">
              Fair Gaming Space NGO
            </span>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-122">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-white/90 hover:text-[#D4A843] font-medium transition-colors text-sm uppercase tracking-wider" data-id="element-123">
                {link.name}
              </a>)}
            <Button variant="secondary" size="sm" className="ml-4" data-id="element-124">
              Підтримати
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button className="md:hidden text-white p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-125">
            {isMobileMenuOpen ? <X size={24} data-id="element-126" /> : <Menu size={24} data-id="element-127" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-[#0A5E5C] border-t border-white/10 shadow-xl p-4 flex flex-col gap-4" data-id="element-128">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-white/90 hover:text-[#D4A843] font-medium py-2 px-4 rounded-md hover:bg-white/5 transition-colors" onClick={() => setIsMobileMenuOpen(false)} data-id="element-129">
              {link.name}
            </a>)}
          <Button variant="secondary" fullWidth onClick={() => setIsMobileMenuOpen(false)} data-id="element-130">
            Підтримати
          </Button>
        </div>}
    </header>;
}